import React from 'react'
import Flash from '../Flash'

export default ({children, onClose, minWidth = '60%', minHeight, maxWidth, flashId}) => (
  <div className='modal is-active'>
    <div className='modal-background' onClick={onClose}></div>
    <div className='modal-content box is-paddingless' style={{minWidth, minHeight, maxWidth}}>
      {flashId && <Flash flashId={flashId} />}
      {children}
    </div>
  </div>
)
